
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { RevenueType } from 'enums/RevenueType';
import { AccountingPlanModel } from './Entities.Accounting.AccountingPlan';
import { Model, ModelProperty } from 'models/Model';


export class RevenueRegistrationModel extends Model<RevenueRegistrationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'type', type: 'RevenueType', languageString: 'revenueRegistration.property.type' },
		{ name: 'id', type: 'guid', languageString: 'revenueRegistration.property.id', isHidden: true },
		{ name: 'workflowProductPlanId', type: 'number', languageString: 'revenueRegistration.property.workflowProductPlanId' },
		{ name: 'customerId', type: 'number', languageString: 'revenueRegistration.property.customerId' },
		{ name: 'customerType', type: 'number', languageString: 'revenueRegistration.property.customerType' },
		{ name: 'productType', type: 'number', languageString: 'revenueRegistration.property.productType' },
		{ name: 'productId', type: 'number', languageString: 'revenueRegistration.property.productId' },
		{ name: 'productDimension', type: 'string', languageString: 'revenueRegistration.property.productDimension' },
		{ name: 'salesTypeDimension', type: 'string', languageString: 'revenueRegistration.property.salesTypeDimension' },
		{ name: 'departmentDimension', type: 'string', languageString: 'revenueRegistration.property.departmentDimension' },
		{ name: 'companyDimension', type: 'string', languageString: 'revenueRegistration.property.companyDimension' },
		{ name: 'createdDate', type: 'Date', languageString: 'revenueRegistration.property.createdDate' },
		{ name: 'value', type: 'number', languageString: 'revenueRegistration.property.value' },
		{ name: 'debitGeneralJournalLineNo', type: 'number', languageString: 'revenueRegistration.property.debitGeneralJournalLineNo' },
		{ name: 'creditGeneralJournalLineNo', type: 'number', languageString: 'revenueRegistration.property.creditGeneralJournalLineNo' },
		{ name: 'period', type: 'number', languageString: 'revenueRegistration.property.period' },
		{ name: 'accountingPlanId', type: 'guid', languageString: 'revenueRegistration.property.accountingPlanId' },
		{ name: 'isAdjustment', type: 'boolean', languageString: 'revenueRegistration.property.isAdjustment' },
		{ name: 'accountingPlan', type: 'AccountingPlanModel', languageString: 'revenueRegistration.property.accountingPlan', isHidden: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public type: RevenueType;
	public id?: string;
	public workflowProductPlanId?: number;
	public customerId?: number;
	public customerType?: number;
	public productType?: number;
	public productId?: number;
	public productDimension: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyDimension: string;
	public createdDate?: Date;
	public value: number;
	public debitGeneralJournalLineNo?: number;
	public creditGeneralJournalLineNo?: number;
	public period?: number;
	public accountingPlanId?: string;
	public isAdjustment?: boolean;
	public accountingPlan?: AccountingPlanModel;
    
	constructor(){
		super();
		this.type = 0;
		this.id = undefined;
		this.workflowProductPlanId = undefined;
		this.customerId = undefined;
		this.customerType = undefined;
		this.productType = undefined;
		this.productId = undefined;
		this.productDimension = '';
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyDimension = '';
		this.createdDate = undefined;
		this.value = 0;
		this.debitGeneralJournalLineNo = undefined;
		this.creditGeneralJournalLineNo = undefined;
		this.period = undefined;
		this.accountingPlanId = undefined;
		this.isAdjustment = undefined;
		this.accountingPlan = undefined;
		
	}
	getProperties(){
		return RevenueRegistrationModel.classProperties;
	}
}

